import { ASIAN_HANDICAP_IT } from "../constants";

export function handleAsianHandicapITDesc(bet) {
    if (ASIAN_HANDICAP_IT.includes(bet.id)) {
        bet.odds.forEach((odd, i) => {
            if (i === 1) {
                odd.betData = {...odd.betData};
                const desc = odd.betData.desc;
                const regex = /(?<betDesc>.+) \((?<spread>.+)\)/;
                if (regex.test(desc)) {
                    const result = regex.exec(desc);
                    if (result != null) {
                        const groups = result.groups;
                        let spread = groups.spread;
                        if (spread[0] === '+') {
                            spread = `-${spread.slice(1)}`;
                        } else if (spread[0] === '-') {
                            spread = `+${spread.slice(1)}`;
                        }
                        odd.betData.desc = `${groups.betDesc} (${spread})`;
                    }
                }
            }
        });
    }
}
